<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29 5.5H11C10.1716 5.5 9.5 6.17157 9.5 7V33C9.5 33.8284 10.1716 34.5 11 34.5H29C29.8284 34.5 30.5 33.8284 30.5 33V7C30.5 6.17157 29.8284 5.5 29 5.5ZM29 4H11C9.34315 4 8 5.34315 8 7V33C8 34.6569 9.34315 36 11 36H29C30.6569 36 32 34.6569 32 33V7C32 5.34315 30.6569 4 29 4Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.25 17C19.25 16.5858 19.5858 16.25 20 16.25H27C27.4142 16.25 27.75 16.5858 27.75 17C27.75 17.4142 27.4142 17.75 27 17.75H20C19.5858 17.75 19.25 17.4142 19.25 17Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.25 11C19.25 10.5858 19.5858 10.25 20 10.25H27C27.4142 10.25 27.75 10.5858 27.75 11C27.75 11.4142 27.4142 11.75 27 11.75H20C19.5858 11.75 19.25 11.4142 19.25 11Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.25 23C19.25 22.5858 19.5858 22.25 20 22.25H27C27.4142 22.25 27.75 22.5858 27.75 23C27.75 23.4142 27.4142 23.75 27 23.75H20C19.5858 23.75 19.25 23.4142 19.25 23Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5303 9.46967C16.8232 9.76256 16.8232 10.2374 16.5303 10.5303L14.5303 12.5303C14.2374 12.8232 13.7626 12.8232 13.4697 12.5303L12.4697 11.5303C12.1768 11.2374 12.1768 10.7626 12.4697 10.4697C12.7626 10.1768 13.2374 10.1768 13.5303 10.4697L14 10.9393L15.4697 9.46967C15.7626 9.17678 16.2374 9.17678 16.5303 9.46967Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303L14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303L12.4697 17.5303C12.1768 17.2374 12.1768 16.7626 12.4697 16.4697C12.7626 16.1768 13.2374 16.1768 13.5303 16.4697L14 16.9393L15.4697 15.4697C15.7626 15.1768 16.2374 15.1768 16.5303 15.4697Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5303 21.4697C16.8232 21.7626 16.8232 22.2374 16.5303 22.5303L14.5303 24.5303C14.2374 24.8232 13.7626 24.8232 13.4697 24.5303L12.4697 23.5303C12.1768 23.2374 12.1768 22.7626 12.4697 22.4697C12.7626 22.1768 13.2374 22.1768 13.5303 22.4697L14 22.9393L15.4697 21.4697C15.7626 21.1768 16.2374 21.1768 16.5303 21.4697Z"
      class="fill-current"
    />
  </svg>
</template>
